@if (isConfigurationOk && clientConfig) {
  <div id="page-container">
    <pub-header-wrapper></pub-header-wrapper>
    <div id="page-content" class="twpub-config-{{clientConfig.id}}">
      <pub-preamble-wrapper></pub-preamble-wrapper>
      <pub-result-view-wrapper></pub-result-view-wrapper>
    </div>
    <pub-footer-wrapper></pub-footer-wrapper>
  </div>
}

